module.exports = __webpack_public_path__ + "static/media/historia.de373a44.jpg";